// extracted by mini-css-extract-plugin
export default {"element":"SideList-module--element--e7643","container":"SideList-module--container--83496","list":"SideList-module--list--e2abd"};